// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:1680px){._2r4HokJcspZi0qkiHZpYJT{display:block;margin:auto;width:1680px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_2r4HokJcspZi0qkiHZpYJT"
};
module.exports = ___CSS_LOADER_EXPORT___;
